module.exports = __webpack_public_path__ + "static/media/classNum_bg@2x.a81c50ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/set_img/classNum_bg@2x.png
// module id = 201
// module chunks = 1